module.exports = __webpack_public_path__ + "img/arrow-down.af2c8136.svg";